import { render } from "./iconKeyboard.vue?vue&type=template&id=cebef06c"
import script from "./iconKeyboard.vue?vue&type=script&lang=js"
export * from "./iconKeyboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__